import React, { useState } from 'react';
import { cx } from './utils';

const initials = (name = '', fallback = 'BB') => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return fallback;
  return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase();
};

const sizes = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-11 w-11 text-sm',
};

// Identidad visual única para responsables, asignaciones y actividad. Si la
// imagen falla o todavía no existe, las iniciales siguen identificando a la
// persona sin romper la vista.
const Avatar = ({ src = '', name = '', fallback = 'BB', size = 'md', className = '' }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const imageUrl = String(src || '').trim();
  return (
    <span
      title={name || fallback}
      className={cx(
        'inline-grid shrink-0 place-items-center overflow-hidden rounded-full border border-white bg-slate-800 font-bold text-white shadow-sm ring-1 ring-slate-200',
        sizes[size] || sizes.md,
        className
      )}
    >
      {imageUrl && !imageFailed ? (
        <img src={imageUrl} alt={name || fallback} className="h-full w-full object-cover" onError={() => setImageFailed(true)} />
      ) : initials(name, fallback)}
    </span>
  );
};

export default Avatar;
